import { Component, OnInit, Renderer2, ElementRef } from '@angular/core';
import { StmgService } from '../../../services/state_Management/stmg.service';
import { BettingServiceService } from '../../../services/betting_service/betting-service.service';
import { CommonServiceService } from 'src/app/services/common_service/common-service.service';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-sports',
  templateUrl: './sports.component.html',
  styleUrls: ['./sports.component.scss'],
})
export class SportsComponent implements OnInit {


  betCat: any = [];
  allCategories: any = [];
  sportIconList: any = [];
  selectedBetCategory: any;
  filter: number = 2;
  inplay: boolean = false;
  country: string = "";
  disable_SP_subscription: Subscription;

  constructor(

    public renderer: Renderer2,
    public ele: ElementRef,
    private stmgService: StmgService,
    private commanService: CommonServiceService,
    private bettingService: BettingServiceService,
    public translate: TranslateService,
  ) {

  }


  ngOnInit() {
    // When refresh hide home page elements
    this.stmgService.setShowHomeElements(false);

    this.stmgService.cast_sportIcons.subscribe(sportIcons => {
      this.sportIconList = sportIcons;
    });

    this.stmgService.language_status.subscribe(message => {
      setTimeout(()=>{
        if (this.sportIconList != "") {
          this.bindSportIcons(this.sportIconList);
        } else {
          this.getSportIcons();
        }
      },500);
      
    });

    //load new data when main nav bar clicked
    this.stmgService.sportRefresh_status.subscribe(message => {
      if (this.sportIconList != "") {
        this.bindSportIcons(this.sportIconList);
      } else {
        this.getSportIcons();
      }
    });

  }


  bindSportIcons(data: any) {

    if (data != "") {
      for (let i = 0; i < data.length; i++) {
        this.allCategories[i] = {
          externalRef: data[i].externalRef,
          id: data[i].id,
          imageIcon: data[i].imageIcon.replace(/\s/g, ""), //remove spaces in base54 img
          sortOrder: data[i].sortOrder,
          sportCode: data[i].sportCode,
          sport_name: data[i].sport_name,
          status: data[i].status,
          active: false,
          filter: this.filter,
          inplay: this.inplay,
          country: this.country,
          showMatchWinner:data[i].showMatchWinner
        };
      }
      this.allCategories[0].active = true;
      // select initial category 
      this.selectedBetCategory = this.allCategories[0];
    }


  }

  // sport categories
  switch_SportCategories(item: any, event: any) {
    if (this.selectedBetCategory == item) {
      this.stmgService.nav2sportRefresh('yes');
    }

    this.selectedBetCategory = item;
    let myTag = this.ele.nativeElement.querySelectorAll("a");
    myTag.forEach(ele => {
      ele.classList.remove('active');
    })

    //set secondary nav bar active color
    if (event.target.id == "aTag") {
      this.renderer.addClass(event.target, 'active');
    } else {
      this.renderer.addClass(event.target.parentNode, 'active');
    }

  }

  // get sport icons for initial load.
  getSportIcons() {
    this.bettingService.getSportIcons().subscribe(data => {
      this.bindSportIcons(data);
      this.updateSportIconsDataSTMG(data);

    })
  }

  updateSportIconsDataSTMG(d: any) {
    this.stmgService.updateSportIcons(d);
  }
}



